import { Component, Input, OnInit, Output,EventEmitter, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { StoreinfoUnitService } from 'src/app/services/storeinfo-Units.service';
import { ILienDetails, ISaveDeleteResponse, IUnitLockDetails } from '../interface';
import { EActionTypes, EElementTypes } from 'src/app/Shared/enum';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';

@Component({
    selector: 'app-facility-locks',
    templateUrl: './facility-locks.component.html',
    styleUrls: ['./facility-locks.component.scss'],
    standalone: false
})
export class FacilityLocksComponent implements OnInit {
  @Input() lockDetailsList;
  @Input() facilityId;
  @Input() unitNo;
  @Input() isNotification = false;
  @Output() emitLockDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output() reLoad: EventEmitter<any> = new EventEmitter<any>();
  loaderIcon: Promise<boolean>;
  eNumActionTypes = EActionTypes;
  eNumElementTypes = EElementTypes;
  lienStage='0';
  lienStagesList=[];
  serialCode ='';
  unlockCode ='';
  lockStatus;
  unitId;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  openModal: boolean = false;
  @ViewChild('syncModalRef', { static: false }) syncModalRef: ModalDirective;
  modalConfig = {
    backdrop: 'static'
  };
  constructor(public unitService: StoreinfoUnitService,private toastr: ToastrService, private modalWrapper: ModalWrapperService) { }

  ngOnInit(): void {
  }

  syncUnitCode(){
    this.loaderIcon = Promise.resolve(true);
    this.unitService.GetUnitLockDetailsFromDaVinci(this.facilityId, this.unitNo).subscribe((response:IUnitLockDetails[]) =>{
      if(response.length > 0){
          this.openModal = true;
          this.loaderIcon = Promise.resolve(false);
          this.lockDetailsList = response;
          this.toastr.success('Lock Sync Completed', 'Success', this.toasterConfig);
      }else{
          this.openModal = false;
          this.lockDetailsList = [];
          this.loaderIcon = Promise.resolve(false);
          this.toastr.warning('No Lock Details Available','Warning', this.toasterConfig);
      }
      this.emitLockDetails.emit(this.lockDetailsList);
    },err => {
        this.openModal = false;
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error('Lock Sync Failed', 'Failure', this.toasterConfig);
    });
  }

  showSelectedRecord(slCode,status){
    if((status == 'Assigned Overlock' || status == 'Assigned Auction') && this.lienStagesList.length >0){
      let lockDetails = this.lockDetailsList.find(e => e.SerialCode == slCode);
      if(lockDetails){
        this.serialCode = lockDetails.SerialCode,
        this.unlockCode = lockDetails.UnlockCode,
        this.lockStatus = lockDetails.LockStatus,
        this.lienStage = lockDetails.LateLienId != undefined && lockDetails.LateLienId != null && lockDetails.LateLienId != '0' ? lockDetails.LateLienId : '0'
      }
    }
  }
  getLienDetails(unitNo){
    this.unitService.getUnitLockLienDetails(unitNo,this.facilityId).subscribe((response:ILienDetails[])=> {
      if(response.length >0){
        this.lienStagesList = response;
      }else{
        this.lienStagesList = [];
      }
    });
  }
  closeModal(){
    this.emitLockDetails.emit(this.lockDetailsList);
    if (this.syncModalRef) {
      this.syncModalRef.hide();
    }
    this.openModal = false;
  }
  updateLienStage(){
    if(this.isNotification){
      this.unitService.updateUnitLockDetails(this.unitId,this.facilityId, this.lockDetailsList).subscribe((response:ISaveDeleteResponse) =>{
        if(response.Success){
          this.toastr.success('Lock Updated Successfully', 'Success', this.toasterConfig);
          this.reLoad.emit();
        }else{
          this.toastr.success('Failed to Update Lock', 'Failure', this.toasterConfig);
        }
        this.closeModal();
      })
    }
    let index = this.lockDetailsList.findIndex(e => e.SerialCode == this.serialCode);
    if(index != -1){
      this.lockDetailsList[index].LateLienName = this.lienStagesList.find(ele=>ele.LateLienId == this.lienStage)?.LateLienName;
      this.lockDetailsList[index].LateLienId = this.lienStage;
      this.serialCode ='';
      this.unlockCode = '';
      this.lockStatus = '';
      this.lienStage = '0';
    }
  }

  openModalPopup() {
    this.openModal = true;
    setTimeout(() => {
      if (this.syncModalRef) {
        this.modalWrapper.openDirective(this.syncModalRef);
      }
    });
  }
}
